export const initialColumns = {
    'column-1': {
        id: 'column-1',
        title: 'To Do',
        cards: []
    },
    'column-2': {
        id: 'column-2',
        title: 'Blocked',
        cards: []
    },
    'column-3': {
        id: 'column-3',
        title: 'In Progress',
        cards: []
    },
    'column-4': {
        id: 'column-4',
        title: 'Ready',
        cards: []
    },
    'column-5': {
        id: 'column-5',
        title: 'Closed',
        cards: []
    }
};

export const columnOrder = ['column-1', 'column-2', 'column-3', 'column-4', 'column-5'];